module.exports = __webpack_public_path__ + "static/media/white.ff3e9eed.png";